export const LIMIT = 100;

export interface QueryPropsModel {
    limit: number;
    skip: number;
    days?: number;
}

export const defaultQueryPropsModel: QueryPropsModel = {
    limit: LIMIT,
    skip: 0,
};

export interface PaginationModel {
    pageSize: number;
    page: number;
}

export type BlastStatus = 'new' | 'loading' | 'success' | 'error';
